const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.71 182.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tAsset 2\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4,126.54V155.6c0,11,.83,17.94,2.49,23.76H58a45.38,45.38,0,0,1-1.16-11h-.33C50,177.2,40.53,181.52,29.07,181.52,10.8,181.52,0,170.39,0,155.6c0-14.45,8.8-23.42,33.56-27.24,6.14-1,15.11-2,20.26-2.32v-3c0-9.47-4.82-13.29-11.79-13.29-7.48,0-11.8,4.15-12,11.79H3.49C4.32,105.6,16,92.31,42,92.31,67.94,92.31,80.4,104.28,80.4,126.54ZM53.82,141.15a118.46,118.46,0,0,0-15,1.66c-8.31,1.66-11.63,4.82-11.63,10.8,0,5.81,3.82,9.64,10.8,9.64,4.15,0,8.64-1.33,11.63-4.32,3.49-3.66,4.15-7.81,4.15-14.79Z",
    style: {
      fill: "#002b5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.1,127.53v51.83H191.52V130.52c0-11-4.15-16.28-11.13-16.28-8.47,0-13.12,7.48-13.12,22.26v42.86H139.69v-50c0-10-4.15-15.12-11.13-15.12-8.63,0-13.28,7.48-13.28,22.26v42.86H87.7V95h25.75v9.64h.33c5.82-7.81,13.46-11.8,23.76-11.8,11.29,0,20.09,4.82,24.91,14.62,6.15-9,14.29-14.62,27.08-14.62C207.63,92.81,219.1,104.61,219.1,127.53Z",
    style: {
      fill: "#002b5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.22,104.11c5.15-7.48,14-11.46,23.09-11.46,21.43,0,35.22,17.44,35.22,44.52s-14.12,44.52-35.88,44.52a27,27,0,0,1-23.43-12.8h-.33v10.47H218.31V61.09h27.58v43Zm-1.83,33.06c0,14.61,6.15,23.58,15.45,23.58,9.64,0,15.78-9.3,15.78-23.58s-6.14-23.59-15.78-23.59C250.54,113.58,244.39,122.55,244.39,137.17Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55,137.17c0,27.4-17.61,44.85-45.18,44.85s-45.19-17.45-45.19-44.85,17.61-44.86,45.19-44.86S394.55,109.76,394.55,137.17Zm-61.3,0c0,14.78,6,23.92,16.12,23.92s16.11-9.14,16.11-23.92-6-23.92-16.11-23.92S333.25,122.38,333.25,137.17Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.71,158.1v20.76a61.49,61.49,0,0,1-14,1.83c-21.09,0-30.4-8.14-30.4-28.08V115.07H388.23V95h13.12V72.22h27.58V95h15.95v20.1H428.93V146.3c0,9,3,12.63,10.63,12.63A23.28,23.28,0,0,0,445.71,158.1Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.42,47.3a5,5,0,0,1-3.84-8.2A17.74,17.74,0,0,0,95.08,10a19,19,0,0,0-14.77,7.25,5,5,0,0,1-8.17.05A19,19,0,0,0,57.34,10,17.74,17.74,0,0,0,43.83,39.1a5,5,0,1,1-7.68,6.4A27.74,27.74,0,0,1,57.34,0,28.86,28.86,0,0,1,76.21,7.1,28.86,28.86,0,0,1,95.08,0a27.74,27.74,0,0,1,21.19,45.5A5,5,0,0,1,112.42,47.3Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,82.15h0a8.71,8.71,0,0,1-6.48-2.93L36.43,45.8a5,5,0,0,1,7.13-7L75.81,71.6,94,53.4A5,5,0,1,1,101,60.46L82.27,79.29A8.75,8.75,0,0,1,75.8,82.15Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.21,56.19a5,5,0,0,1-5-5V30.05a5,5,0,1,1,10,0V51.19A5,5,0,0,1,76.21,56.19Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.78,45.62H65.64a5,5,0,0,1,0-10H86.78a5,5,0,0,1,0,10Z",
    style: {
      fill: "#ffffff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbot);
export default __webpack_public_path__ + "static/media/ambot.7ceca11b4d38fea1be5bbb4d5b2d75c8.svg";
export { ForwardRef as ReactComponent };